import { Radio, type RadioProps } from 'react-aria-components';
import type { ReactElement } from 'react';
import cx from 'clsx';
import styles from './radio-button.module.css';

export type RadioButtonProps<T extends string> = Omit<RadioProps, 'value'> & {
  value: T;
};

export function RadioButton<T extends string>({
  className,
  ...props
}: RadioButtonProps<T>): ReactElement {
  return (
    <Radio
      className={cx(styles.radio, 'body-standard', className)}
      {...props}
      data-test-radio-button
    />
  );
}
